import { THANK_YOU_URL_PATTERN } from '../config.js';
import { buildHubSpotIdentifyPayload } from '../identify/hubspot-builder.js';
import { buildAmplitudeIdentifyCall } from '../identify/amplitude-builder.js';
import { hsqIdentify, hsqTrackPageView } from '../services/hubspot.js';
import { amplitudeIdentify } from '../services/amplitude.js';
import { logger } from '../utils/logger.js';

/**
 * Vrai si l'URL courante est une thank you page (/contact/merci-*).
 */
export function isThankYouPage(pathname: string = window.location.pathname): boolean {
  return pathname.includes(THANK_YOU_URL_PATTERN);
}

/**
 * Sur une thank you page, pousse un second identify HubSpot + Amplitude de sécurité.
 * Appelé par l'orchestrateur après DOMContentLoaded.
 *
 * No-op si pas sur une TY page.
 * Aucun event Amplitude custom n'est émis (décision PO validée).
 */
export function handleThankYouPage(): void {
  if (!isThankYouPage()) return;

  logger.info('Thank you page détectée:', window.location.pathname);

  // Second identify HubSpot (filet de sécurité, async car hash email)
  buildHubSpotIdentifyPayload('thankyou')
    .then((hsPayload) => {
      hsqIdentify(hsPayload);
      hsqTrackPageView();
    })
    .catch((error) => {
      logger.error('Erreur HubSpot identify sur thank you page:', error);
    });

  // Second identify Amplitude (filet de sécurité)
  if (window.amplitude) {
    amplitudeIdentify(buildAmplitudeIdentifyCall());
  } else {
    logger.warn('Amplitude pas chargé sur la thank you page');
  }
}
